import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';
import type { ProcessStep } from './process-steps';

interface ProcessStepItemProps {
  readonly step: ProcessStep;
  /** 1부터 — 두 자리 번호로 싣는다. */
  readonly order: number;
  /** 마지막 단계 — 잇는 선을 그리지 않고 점을 라임으로 채운다. */
  readonly isLast: boolean;
}

/**
 * 진행 단계 한 칸. 좁은 화면은 왼쪽 세로선, 넓은 화면(lg)은 위 가로선으로 다음 단계와 잇는다.
 */
export const ProcessStepItem = ({ step, order, isLast }: ProcessStepItemProps): ReactElement => (
  <li className={cn('relative pl-10 lg:pt-12 lg:pr-6 lg:pl-0', !isLast && 'pb-10 lg:pb-0')}>
    {isLast ? null : (
      <span
        aria-hidden
        className="absolute top-5 bottom-0 left-[7px] w-px bg-foreground/15 lg:top-[7px] lg:right-0 lg:bottom-auto lg:left-5 lg:h-px lg:w-auto"
      />
    )}
    <span
      aria-hidden
      className={cn(
        'absolute top-0.5 left-0 size-4 rounded-full border-2 border-foreground lg:top-0',
        isLast ? 'bg-brand-lime' : 'bg-background',
      )}
    />
    <div className="flex flex-col gap-2">
      <span className="text-[13px] font-semibold text-muted-foreground tabular-nums">
        STEP {String(order).padStart(2, '0')}
      </span>
      <h3 className="text-xl font-bold tracking-[-0.02em]">{step.title}</h3>
      <p className="text-[15px] leading-relaxed text-muted-foreground">{step.description}</p>
    </div>
  </li>
);
